package com.essntl.features.organization.data.repository

import com.essntl.core.supabase.getAll
import com.essntl.core.supabase.getById
import com.essntl.core.supabase.getCount
import com.essntl.core.supabase.update
import com.essntl.core.utils.repository.Repository
import com.essntl.features.organization.data.supabase.OrganizationDto
import com.essntl.features.organization.data.supabase.OrganizationSupabaseDataSource
import com.essntl.features.organization.data.supabase.toDto
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.organization.domain.repository.OrganizationRepository
import org.koin.core.annotation.Single

@Single(binds = [OrganizationRepository::class])
internal class OrganizationRepositoryImpl(
    private val supabase: OrganizationSupabaseDataSource,
) : OrganizationRepository, Repository() {

    override suspend fun getAll(
        page: Long,
        limit: Int,
        query: String,
        type: OrganizationModel.Type?,
    ): Result<List<OrganizationModel>> =
        runCatching {
            supabase.getAll(
                page = page,
                limit = limit,
                columns = OrganizationDto.getColumns(),
            ) {
                filter {
                    if (query.isNotEmpty())
                        ilike("name", "%$query%")

                    if (type != null)
                        eq("type", type.toDto())
                }
            }.map { dto -> dto.toModel() }
        }

    override suspend fun get(id: String): Result<OrganizationModel> =
        runCatching {
            supabase
                .getById(
                    id = id,
                    columns = OrganizationDto.getColumns(),
                )
                .toModel()
        }

    override suspend fun update(organization: OrganizationModel): Result<OrganizationModel> =
        runCatching {
            supabase
                .update(
                    id = organization.id,
                    requestMap = organization.toRequestMap(),
                    columns = OrganizationDto.getColumns(),
                ).toModel()
        }

    override suspend fun getCountOrganizationsByLogo(logoId: String): Result<Long> =
        runCatching {
            supabase.getCount {
                filter {
                    eq("logo_file_id", logoId)
                }
            }
        }
}
